import { useCallback } from "react";
import type { SlashCommand } from "../types/command-types";

/**
 * "/" ile başlayan mesajları slash command olarak işleyen ortak form submit
 * handler'ı. ChatInput ve MobileChatInput'ta duplike edilen mantığın tek
 * kaynağı.
 *
 * - Mesaj "/" ile başlıyorsa: shortcut resolve edilir, komut bulunursa
 *   çalıştırılır; komut bulunsun bulunmasın mesaj API'ye gönderilmez.
 * - Aksi halde normal submit çalışır.
 */
export const useSlashCommandFormSubmit = (
  message: string,
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void | Promise<void>,
  handleSlashCommandSelect: (command: SlashCommand) => Promise<unknown> | unknown
) => {
  return useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (message.trim().startsWith("/")) {
        let commandText = message.trim().split(" ")[0];

        // Shortcut resolve
        const { useSlashCommandStore } = await import(
          "../store/slash-command-store"
        );
        const shortcuts = useSlashCommandStore.getState().shortcuts;
        if (shortcuts[commandText]) {
          commandText = shortcuts[commandText];
        }

        const { findCommandByTrigger } = await import(
          "../registry/command-registry"
        );
        const command = findCommandByTrigger(commandText);

        if (command) {
          await handleSlashCommandSelect(command);
        }

        // Command bulunsun bulunmasın, API'ye gitmesin
        return;
      }

      // Normal submit
      handleSubmit(e);
    },
    [message, handleSubmit, handleSlashCommandSelect]
  );
};
